// assets
import { AccountIcon } from 'components/icons/sidebarIcons';
import { AssignmentInd, GroupAdd, HomeWork, PersonPin } from "@mui/icons-material";

// constant
export const icons = {
    AssignmentInd,
    GroupAdd,
    HomeWork,
    PersonPin
};

const account = {
    id: 'account',
    title: 'side_menu.account',
    type: 'group',
    roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
    collapse: false,
    icon: "PersonPin", //icons.PersonPin,
    children: [
        {
            id: 'account-user-profile',
            title: 'side_menu.user_profile',
            type: 'item',
            url: 'account/user-profile',
            icon: 'AssignmentInd', //icons.AssignmentInd,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'demo', 'sales', 'admin', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'account-additional-users',
            title: 'side_menu.additional_users',
            type: 'item',
            url: 'account/additional-users',
            icon: 'GroupAdd', //icons.GroupAdd,
            breadcrumbs: false,
            roles: ['user', 'demo', 'sales', 'admin', 'superadmin', 'it'],
        },
        {
            id: 'account-organization-profile',
            title: 'side_menu.organization_profile',
            type: 'item',
            url: 'account/organization-profile',
            icon: 'HomeWork', //icons.HomeWork,
            breadcrumbs: false,
            roles: ['user', 'demo', 'sales', 'admin', 'superadmin', 'it'],
        }
    ]
};

export default account;
